import { useEffect } from "react";

import { useThemeStore } from "@/hooks/ui/useThemeStore";

export function ThemeInitializer() {
	const theme = useThemeStore((state) => state.theme);

	useEffect(() => {
		const root = window.document.documentElement;
		root.classList.remove("light", "dark");
		root.classList.add(theme);
	}, [theme]);

	return null;
}
